package com.rdapps.weddinginvitation.model

enum class Page {
    Home,
    June28,
    June29,
    June30,
    July3
}